import {
	addDays,
	addMonths,
	eachDayOfInterval,
	endOfMonth,
	format,
	isSameMonth,
	startOfMonth,
} from "date-fns";
import { ptBR } from "date-fns/locale";
import { currentWorkDay, dateToDateOnly } from "@/lib/format";
import type { PeriodKind, WeekRange } from "../types";
import {
	isCurrentWeek,
	shiftWeeks,
	weekDates,
	weekLabel,
	weekRange,
	weekStart,
} from "./week";

export function periodRange(kind: PeriodKind, reference: Date): WeekRange {
	if (kind === "week") return weekRange(reference);
	return {
		from: dateToDateOnly(startOfMonth(reference)),
		to: dateToDateOnly(endOfMonth(reference)),
	};
}

export function periodDates(kind: PeriodKind, reference: Date): Date[] {
	if (kind === "week") return weekDates(reference);
	return eachDayOfInterval({
		start: startOfMonth(reference),
		end: endOfMonth(reference),
	});
}

export function shiftPeriod(
	kind: PeriodKind,
	reference: Date,
	amount: number,
): Date {
	if (kind === "week") return shiftWeeks(reference, amount);
	return addMonths(reference, amount);
}

export function isCurrentPeriod(kind: PeriodKind, reference: Date): boolean {
	if (kind === "week") return isCurrentWeek(reference);
	return isSameMonth(reference, currentWorkDay());
}

export function periodLabel(kind: PeriodKind, reference: Date): string {
	if (kind === "week") return weekLabel(reference);
	const label = format(reference, "MMMM 'de' yyyy", { locale: ptBR });
	return label.charAt(0).toUpperCase() + label.slice(1);
}

export function periodStart(kind: PeriodKind, reference: Date): Date {
	return kind === "week" ? weekStart(reference) : startOfMonth(reference);
}

export function periodEnd(kind: PeriodKind, reference: Date): Date {
	return kind === "week"
		? addDays(weekStart(reference), 6)
		: endOfMonth(reference);
}
